export const workVideoData = [
  {
    category: "musicVideo",
    link: "airplane-ticket",
    imgUrl: "airplane-tix.WebP",
    vidlink: "Airplane-Tickets.mp4",
    photoshoot: false,
    title: "Airplane Tickets",
    director: "Maxime Quoilin",
    description1: "Good Company",
    description2: "Ellis Fox",
  },
  {
    category: "featureFilm",
    link: "her",
    imgUrl: "her.WebP",
    vidlink: "her.mp4",
    photoshoot: false,
    title: "Her",
    director: "Spike Jonze",
    description1: "Annapurna Pictures",
    description2: "Warner Brothers",
  },
  {
    category: "featureFilm",
    link: "snowden",
    title: "Snowden",
    imgUrl: "snowden.WebP",
    vidlink: "snowden.mp4",
    photoshoot: false,
    director: "Oliver Stone",
    description1: "Open Road Films, Wild Bunxh, Endgame Entertainment",
    description2: "TG Media, Warner Brothers",
  },
  {
    category: "tvCommercial",
    link: "adidas1",
    title: "Adidas - Create the Answer",
    imgUrl: "adidas.WebP",
    vidlink: "create-the-answer.mp4",
    photoshoot: false,
    director: "Manu Cossu",
    description1: "Iconoclast/Anonymous Content",
    description2: "72 and Sunny",
  },
  {
    category: "tvCommercial",
    link: "ipad",
    title: "Apple Ipad Air",
    imgUrl: "ipad.WebP",
    vidlink: "ipadAir.mp4",
    photoshoot: false,
    director: "Julios Metoyer",
    description1: "MAL",
    description2: "Apple",
  },
  {
    category: "tvCommercial",
    link: "samsung",
    title: "Samsung Galaxy S9",
    imgUrl: "maxresdefault.WebP",
    vidlink: "GalaxyS9-JetLag.mp4",
    photoshoot: false,
    director: "Isaiah Seret",
    description1: "Buscuit Filmworks",
    description2: "Wieden & Kennedy",
  },
  {
    category: "tvCommercial",
    link: "adidas-original",
    title: "Adidas - Originals",
    imgUrl: "adidasoriginals.WebP",
    vidlink: "adidasOriginals.mp4",
    photoshoot: false,
    director: "",
    description1: "",
    description2: "",
  },
  {
    category: "tvCommercial",
    link: "pandg",
    title: "P&G Moms",
    imgUrl: "png.WebP",
    vidlink: "pandg.mp4",
    photoshoot: false,
    director: "Alejandro Gonzalez Iñárritu",
    description1: "Anonymous Content",
    description2: "Wieden & Kennedy",
  },
  {
    category: "tvCommercial",
    link: "adidas-billion",
    title: "Adidas - One in a Billion",
    imgUrl: "adidas-onebilliion.WebP",
    vidlink: "adidasOneInaBillion.mp4",
    photoshoot: false,
    director: "Max Malkin",
    description1: "PrettyBird",
    description2: "72 and Sunny",
  },
  {
    category: "tvCommercial",
    link: "vodafone",
    title: "Vodafone",
    imgUrl: "vodafone.WebP",
    vidlink: "vodafone.mp4",
    photoshoot: false,
    director: "Sebastian Strasser",
    description1: "Radical Media",
    description2: "Jung Van Matt",
  },

  {
    category: "documentary",
    link: "inconvenient-truth",
    title: "An Inconvenient Truth",
    imgUrl: "inconvenient.WebP",
    vidlink: "inconvenientTruth.mp4",
    photoshoot: false,
    director: "Davis Guggenheim",
    description1: "Participant Media",
    description2: "Starring Al Gore",
  },

  {
    category: "television",
    link: "better-late-than-never",
    title: "Better Late Than Never",
    imgUrl: "betterlate.WebP",
    vidlink: "betterLate.mp4",
    photoshoot: false,
    director: "Troy Miller",
    description1: "NBC Universal",
    description2: "NBC",
  },
  {
    category: "television",
    link: "amazing_race",
    title: "Amazing Race",
    imgUrl: "amazing_race.WebP",
    vidlink: "amazing_race.mp4",
    photoshoot: false,
    director: "Bertram Van Munster",
    description1: "World Race Productions",
    description2: "CBS",
  },
  {
    category: "television",
    link: "richkids",
    title: "Rich Kids of Beverly Hills",
    imgUrl: "richkids.WebP",
    vidlink: "richkids.mp4",
    photoshoot: false,
    director: "Adam Sampson",
    description1: "ITV Studios America",
    description2: "E! Entertainment",
  },
  {
    category: "television",
    link: "who-do-you-think-you-are",
    title: "Who Do You Think You Are",
    imgUrl: "whodoyou.WebP",
    vidlink: "whoyouthink.mp4",
    photoshoot: false,
    director: "Jeremy Finn",
    description1: "The Learning Channel",
    description2: "Shed Media",
  },
  {
    category: "tvCommercial",
    link: "lotto-red",
    title: "Danish Lottery - Red Dragon",
    imgUrl: "red-dragon.WebP",
    vidlink: "dragonO.mp4",
    photoshoot: false,
    director: "Axel Laubsher",
    description1: "Social Club, Sweden",
    description2: "Forstmann",
  },
  {
    category: "photography",
    link: "vogue",
    title: "Vogue - Mario Testino Special Edition",
    imgUrl: "MT-vogue.WebP",
    vidlink: "",
    photoshoot: true,
    director: "Mario Testino",
    description1: "Art Partner",
    description2: "Shu Qi and He Sui",
  },
  {
    category: "photography",
    link: "pirelli",
    title: "Pirelli Calendar 2008",
    imgUrl: "pirelli-calendar.WebP",
    vidlink: "",
    photoshoot: true,
    director: "",
    description1: "",
    description2: "",
  },
  {
    category: "photography",
    link: "annie",
    title: "Annie Liebovitz - Women",
    imgUrl: "annieLeb.WebP",
    vidlink: "",
    photoshoot: true,
    director: "Photo Exhibition",
    description1: "June 2016",
    description2: "Honk Kong",
  },
  {
    category: "tvCommercial",
    link: "xbox",
    title: "Microsoft Xbox",
    imgUrl: "xbox.WebP",
    vidlink: "xbox.mp4",
    photoshoot: false,
    director: "Rupert Sanders",
    description1: "MJZ",
    description2: "McCann Erickson",
  },
  {
    category: "photography",
    link: "dior",
    title: "Lady Dior",
    imgUrl: "dior.WebP",
    vidlink: "",
    photoshoot: true,
    director: "Steven Klein",
    description1: "N6 London",
    description2: "Marion Cottliard",
  },
  {
    category: "tvCommercial",
    link: "citibank",
    title: "Citibank",
    imgUrl: "citi.WebP",
    vidlink: "citi.mp4",
    photoshoot: false,
    director: "",
    description1: "",
    description2: "",
  },
  {
    category: "tvCommercial",
    link: "cisco",
    title: "Cisco",
    imgUrl: "cisco.WebP",
    vidlink: "cisco.mp4",
    photoshoot: false,
    director: "Tarsem Singh",
    description1: "Shanghai Production",
    description2: "",
  },
];

export const workNavData = [
  {
    category: "allWork",
    text: "All Work",
  },
  {
    category: "tvCommercial",
    text: "Commercials",
  },
  {
    category: "television",
    text: "Television",
  },
  {
    category: "photography",
    text: "Photography",
  },
  {
    category: "featureFilm",
    text: "Feature Films",
  },
  {
    category: "documentary",
    text: "Documentary",
  },
  {
    category: "musicVideo",
    text: "Music Videos",
  },
];

export const ImageSelect = [
  {
    src: "pirelli2.WebP",
  },
  {
    src: "pirelli3.WebP",
  },
  {
    src: "pirelli4.WebP",
  },
  {
    src: "pirelli5.WebP",
  },
  {
    src: "pirelli6.WebP",
  },
  {
    src: "pirelli7.WebP",
  },
  {
    src: "pirelli8.WebP",
  },
  {
    src: "pirelli9.WebP",
  },
  {
    src: "pirelli10.WebP",
  },
];
